module.exports = __webpack_public_path__ + "static/banner-32da6f29eeabd6d35731bed3f581b94a.jpg";